/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input } from '@angular/core';
import { Organization } from '../../../shared/models/organization';

/**
 * Shared shell for the v3 public auth pages (login, signup, alumni login,
 * prearrivals login, invitation join): the background/maintenance-overlay `<main>`
 * plus the centered card, with the page-specific content projected in.
 */
@Component({
  selector: 'ptl-v3-auth-layout',
  templateUrl: './v3-auth-layout.component.html',
  styleUrls: ['./v3-auth-layout.component.scss'],
})
export class V3AuthLayoutComponent {
  @Input() organizationData: Organization;
  @Input() showMaintenanceOverlay = false;

  get isSplitScreen(): boolean {
    return this.organizationData?.landingPage?.layout === 'SPLIT_SCREEN';
  }

  get brandLogoUrl(): string {
    const landingPage = this.organizationData?.landingPage;
    return landingPage?.landingLogoV3 || landingPage?.landingLogo || this.organizationData?.logo;
  }

  get backgroundImageStyle(): string {
    const backgroundImage = this.organizationData?.landingPage?.backgroundImage;
    return backgroundImage ? `url('${backgroundImage}')` : '';
  }

  get backgroundColorStyle(): string {
    const landingPage = this.organizationData?.landingPage;
    return landingPage?.useBackgroundColourFill ? landingPage.backgroundColour : '';
  }
}
